import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";

import { CheckBox, TextField, Loadable } from "components/support";

import style from "./style";

class CompanyIntegrationsMercadoPagoView extends Component {
  render() {
    const { className, presenter, viewModel } = this.props;
    const { mercado_pago } = viewModel.company.integrations;
    const { enabled, token } = mercado_pago;
    const { loading } = viewModel;

    return (
      <div className={`${className} grid-container`}>
        <Loadable loading={loading}>
          <Row>
            <Col xs={12}>
              <div className="grid-container mt-sm mb-sm">
                <Typography type="headline">Mercado Pago</Typography>
                <hr />
                <Row bottom="xs">
                  <Col xs={12}>
                    <div className="integration-status">
                      <CheckBox
                        checked={enabled}
                        style={{ paddingLeft: 4 }}
                        label="Status Integração"
                        onCheck={checked => presenter.manageCheckbox(checked)}
                      />
                      <div className="tooltip">
                        <Tooltip
                          key="tooltip-top-mercado-pago"
                          title="Assinale para ativar/desativar a integração com o Mercado Pago"
                          placement="top"
                        >
                          <Icon className="tooltip-icon">info</Icon>
                        </Tooltip>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <TextField
                      fullWidth
                      label="Token do Mercado Pago"
                      value={token}
                      onChange={(_, value) =>
                        presenter.enqueueMercadoPagoField("token", value)
                      }
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Loadable>
      </div>
    );
  }
}

export default style(CompanyIntegrationsMercadoPagoView);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/mercado-pago/view.jsx